import { render } from "./ServicesRequired.vue?vue&type=template&id=260aec48&ts=true"
import script from "./ServicesRequired.ts?vue&type=script&lang=ts&external"
export * from "./ServicesRequired.ts?vue&type=script&lang=ts&external"

import "./ServicesRequired.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__